/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_No_BidsInputs */

const en_directory_vibebids_no_bids = /** @type {(inputs: Directory_Vibebids_No_BidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No live bids in this category yet.`)
};

const zh_directory_vibebids_no_bids = /** @type {(inputs: Directory_Vibebids_No_BidsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该分类暂时还没有实时出价。`)
};

/**
* | output |
* | --- |
* | "No live bids in this category yet." |
*
* @param {Directory_Vibebids_No_BidsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_no_bids = /** @type {((inputs?: Directory_Vibebids_No_BidsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_No_BidsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_no_bids(inputs)
	return zh_directory_vibebids_no_bids(inputs)
});
export { directory_vibebids_no_bids as "directory.vibebids.no_bids" }